import axios from "axios";
import { APIURL } from "../../../APIHandler/APIURL"
import { Headers } from "../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../utlis/utlis";
import { SetPassword_failure, SetPassword_request, SetPassword_success } from "../../Reducer/ForgetPassword/SetPassword";

export const SetConfirmPasswordAPI = (payload) => async (dispatch, getState) => {
    dispatch(SetPassword_request())
    const auth_token = localStorage.getItem("auth_token")
    try {

        const { data } = await axios.post(`${APIURL.setpassword}`,payload, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
               "event-slug":Headers?.["event-slug"],
                // "Content-type": "application/json",
                "Content-type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${auth_token}`
            },
        })
        // console.log("data", data)
        dispatch(SetPassword_success(data))
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(SetPassword_failure(error?.response?.data))

    }
}